'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var Icon = require('../components/H3Icon')["default"];

var _asn = require('./asn-all');

var config = require('../config');

var utils = require('../utils');

function getIconName(name) {
  return "".concat(utils.upperFirst(config.componentOptions.prefix)).concat(utils.pascail(name));
}

function getIconComponent(name) {
  var component = {
    name: getIconName(name),
    displayName: name,
    functional: true,
    props: _objectSpread({}, Icon.props),
    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children,
          props = _ref.props;
      return h(Icon, _objectSpread(_objectSpread({}, data), {}, {
        props: _objectSpread(_objectSpread(_objectSpread({}, data.props), props), {}, {
          icon: _asn[name]
        })
      }), children);
    }
  };
  return component;
}

Object.keys(_asn).forEach(function (key) {
  if (key === 'default' || key === '__esModule') return;
  Object.defineProperty(exports, getIconName(key), {
    enumerable: true,
    get: function get() {
      return getIconComponent(key);
    }
  });
});